// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa'; 
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop'; 
import Home from './pages/Home';
import Inventory from './pages/Inventory';
import VehicleDetails from './pages/VehicleDetails';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard'; 
import Login from './pages/Login'; 
import Signup from './pages/Signup'; 
import ForgotPassword from './pages/ForgotPassword'; 
import ProtectedRoute from './components/ProtectedRoute'; 
import GeneralGoods from './pages/GeneralGoods'; 
import { About, Careers, Export } from './pages/StaticPages';
import './App.css';

// Import the logo
import logo from './assets/cremlora llc logo grey.jpg';

// Footer Component (2-Column Layout)
const Footer = () => (
  <footer style={{
      background: 'linear-gradient(110deg, #051337 0%, #1b2e4b 40%, #5d6d7e 50%, #1b2e4b 60%, #051337 100%)',
      color: '#f4f4f4', 
      padding: '60px 20px', 
      marginTop: '60px',
      borderTop: '3px solid var(--accent-blue)',
      textShadow: '0 1px 2px rgba(0,0,0,0.8)' 
  }}>
    <div className="container" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '50px'}}>
        <div>
            <div style={{marginBottom: '30px'}}>
                <img 
                  src={logo} 
                  alt="Cremlora LLC" 
                  style={{ height: '100px', width: 'auto', objectFit: 'contain', marginBottom: '15px', display: 'block' }} 
                />
                <h4 style={{fontSize: '1.5rem', marginBottom: '10px', color: '#ffffff'}}>Cremlora LLC</h4>
                <p style={{color: '#d1d5db', fontStyle: 'italic'}}>Driven by Trust.</p>
            </div>
            <div>
                <h4 style={{fontSize: '1.2rem', marginBottom: '15px', color: '#ffffff'}}>Contact Us</h4>
                <p style={{marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px', color: '#e0e0e0'}}>
                    <span></span> 2785 terrace grove drive Conroe, TX 77304, USA
                </p>
                <p style={{display: 'flex', alignItems: 'center', gap: '10px', color: '#e0e0e0'}}>
                    <span></span> (850) 736-4448
                </p>
            </div>
        </div>
        <div>
            <h4 style={{fontSize: '1.2rem', marginBottom: '20px', color: '#ffffff'}}>Quick Links</h4>
            <ul style={{listStyle:'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '12px'}}>
                <li><a href="/inventory" style={{color: '#ffffff', textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.3)', paddingBottom: '5px', display: 'block'}}>Browse Dealership</a></li>
                <li><a href="/general-goods" style={{color: '#ffffff', textDecoration: 'none', borderBottom: '1px solid rgba(255,255,255,0.3)', paddingBottom: '5px', display: 'block'}}>General Goods</a></li>
                
                {/* Updated Warranty Section */}
                <li style={{ borderBottom: '1px solid rgba(255,255,255,0.3)', paddingBottom: '10px' }}>
                    <span style={{ color: '#ffffff', display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Warranty Information</span>
                    <p style={{ fontSize: '0.9rem', color: '#d1d5db', margin: '0 0 5px 0', lineHeight: '1.4' }}>
                        All Used* Vehicles purchased as it is will have no warranty.
                    </p>
                    <p style={{ fontSize: '0.9rem', color: '#d1d5db', margin: '0', lineHeight: '1.4' }}>
                        All Certified-Used** Vehicles will have a 30-day return warranty policy.
                    </p>
                </li>
            </ul>
        </div>
    </div>
    <div style={{textAlign: 'center', marginTop: '50px', borderTop: '1px solid rgba(255,255,255,0.2)', paddingTop: '20px', fontSize:'0.85rem', color: '#d1d5db'}}>
        &copy; 2026 Cremlora LLC. All Rights Reserved. <br />
        <small style={{color: '#b0b0b0'}}><i>powered by AS Tech. World & ValuVant Solutions</i></small>
    </div>
  </footer>
);

function App() {
  const whatsappNumber = "8507364448"; 
  const defaultMessage = "Hello! I am interested in a vehicle from Cremlora LLC.";

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/general-goods" element={<GeneralGoods />} /> 
        <Route path="/vehicle/:id" element={<VehicleDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/export" element={<Export />} />
        <Route path="/finance" element={<div className="container" style={{padding:'50px'}}><h2>Finance Application Coming Soon</h2></div>} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        
      </Routes>
      <Footer />
      
      <a 
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-widget"
      >
        <FaWhatsapp />
      </a>
    </Router>
  );
}

export default App;